import React from "react";
import { connect } from "react-redux";
import { Button, Grid } from "semantic-ui-react";
import OrgTreeButton from "../buttons/OrgTreeButton";
import { fetchCustomerFilters } from "@actions";
import ExpandButton from "@buttons/ExpandButton";
import useCustomerView from "@hooks/useCustomerView";
import StatusLabels from "@common/components/shared/StatusLabels";
import SimpleInputComponent from "@common/components/shared/forms/SimpleInputComponent";
import DatePeriodFilters from "@common/components/shared/DatePeriodFilters";
import useCustomerFilters from "@hooks/useCustomerFilters";
import SimpleSelectComponent from "@forms/SimpleSelectComponent";

const CustomerFilters = (props) => {
  const { showOrgTree } = props.filters;
  const {
    reviewStatusCounts,
    selectedCustomer,
    customerName,
    hideDetails,
    setState,
    onInputChange,
    onStatusChange,
    getRecords,
  } = useCustomerView();

  const {
    showExtraFilters,
    selectedCustomerState,
    customerStatusTypes,
    lastInteractionDateFrom,
    lastInteractionDateTo,
    onDatesChange,
    onCustomerStateChange,
    toggleExtraFilters,
  } = useCustomerFilters();

  return (
    <Grid>
      <Grid.Row className="flex-row-center">
        <Grid.Column width={2} className="flex-row-center">
          <OrgTreeButton
            active={showOrgTree}
            onClick={() =>
              props.fetchCustomerFilters({
                showOrgTree: !showOrgTree,
              })
            }
          />
          <Button
            icon="filter"
            color="blue"
            basic={!showExtraFilters}
            onClick={toggleExtraFilters}
          />
        </Grid.Column>
        <Grid.Column width={5} >
            <label>
              <b>Interaction Date:</b>
            </label>
            <div className="w-100 flex-row-center">
              <DatePeriodFilters
                fromDate="lastInteractionDateFrom"
                toDate="lastInteractionDateTo"
                onChange={onDatesChange}
                data={{ lastInteractionDateFrom, lastInteractionDateTo }}
                showTimeFilters={false}
                inputWidth="140px"
              />
            </div>
        </Grid.Column>
        <Grid.Column width={3}>
          <SimpleInputComponent
            name="customerName"
            label="Customer search:"
            className=""
            labelClassName=""
            value={customerName}
            onChange={onInputChange}
          />
        </Grid.Column>
        <Grid.Column
          width={5}
          className="flex-row-center"
          style={{ marginBottom: "-1.5em" }}
        >
          <Button
            positive
            icon="refresh"
            content="Refresh"
            onClick={getRecords}
          />
          {selectedCustomer && (
            <ExpandButton
              content={hideDetails ? "Show Details" : "Hide Details"}
              compact={false}
              onClick={() => setState({ hideDetails: !hideDetails })}
            />
          )}
        </Grid.Column>
      </Grid.Row>
      {showExtraFilters && (
        <Grid.Row className="flex-row-center">
          <Grid.Column width={7} style={{ marginBottom: "-2em" }}>
            <StatusLabels
              labels={reviewStatusCounts}
              onClick={onStatusChange}
            />
          </Grid.Column>
          <Grid.Column width={5}>
            <SimpleSelectComponent
              className=""
              label="Customer state:"
              labelClassName=""
              options={customerStatusTypes}
              value={selectedCustomerState}
              onChange={onCustomerStateChange}
            />
          </Grid.Column>
        </Grid.Row>
      )}
    </Grid>
  );
};

const mapStateToProps = (state) => {
  return {
    filters: state.customerFilters,
  };
};

export default connect(mapStateToProps, { fetchCustomerFilters })(
  CustomerFilters,
);
